const hideMobile = {
  methods: {
    hideMobile() {
      if (document.body.classList.contains('sidebar-show')) {
        document.body.classList.toggle('sidebar-show')
      }
    }
  }
}

export { hideMobile }



//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/vue/src/mixins/hideMobile.js
// module id = pIQu
// module chunks = 0